import * as React from "react";
import { useState, useEffect } from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import Container from "@mui/material/Container";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { Link } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import { NavLink } from "react-router-dom";


const NavButton = ({ name, link }) => {
   const [classes, setClasses] = useState('box');
   const [brightness, setBrightness] = useState('100%');

   return (
      <a href={link}><Button
         endIcon={
            <img alt='chevron-right' src={"./assets/media/chevron.png"} className={classes} />
         }
         onMouseEnter={() => { setClasses('box bounce-1'); setBrightness("90%") }}
         onMouseLeave={() => { setClasses('box'); setBrightness("100%") }}
         sx={{
            width: "125px",
            display: "flex",
            border: "1px solid white",
            height: "100%",
            borderRadius: "0px",
            color: "white !important",
            fontWeight: "900",
            filter: `brightness(${brightness})`
         }}
      >
         {name}
      </Button></a>
   );
};



const getUrl = window.location;
const baseUrl = getUrl.protocol + "//" + getUrl.host;

const pages = [
   { name: "overview", link: `/`, active: false },
   { name: "investors", link: `/#custom-stop`, active: false },
   { name: "agenda", link: `/agenda`, active: false },
   { name: "matchmaking", link: `/matchmaking`, active: false },
   { name: "sponsors", link: `/sponsors`, active: false },
   // { name: "venue", link: `/venue`, active: false },
   // { name: "faq", link: `/FAQ` },
   // { name: "press", link: `/press-passes`, active: false },
   // { name: "presenters", link: `/presenters`, active: false  },
];
const settings = ["Profile", "Account", "Dashboard", "Logout"];


export const NavBarFinal = () => {
   const [open, setOpen] = useState(false);
   const [anchorElNav, setAnchorElNav] = useState(null);
   const [anchorElUser, setAnchorElUser] = useState(null);
   const [chevron3, setChevron3] = useState(0);
   const [chevron4, setChevron4] = useState(0);
   const [margin3, setMargin3] = useState("0vw");
   const [margin4, setMargin4] = useState("0vw");

   useEffect(() => {
      const script = document.createElement('script');
      script.src = 'https://js.hsforms.net/forms/v2.js';
      document.body.appendChild(script);

      script.addEventListener('load', () => {
         if (window.hbspt) {
            window.hbspt.forms.create({
               portalId: '536350',
               formId: '5f67c12f-e4b9-4386-950a-ce96f986918f',
               target: '#preregisterForm'
            })
         }
      });
   }, [open]);

   const handleOpenNavMenu = (event) => {
      setAnchorElNav(event.currentTarget);
   };

   const handleCloseNavMenu = () => {
      setAnchorElNav(null);
   };

   const handleCloseUserMenu = () => {
      setAnchorElUser(null);
   };

   const handleClose = () => {
      setOpen(false);
   };

   const NavLinkButton = ({ page }) => {
      const [active, setActive] = useState(false)

      return (
         page.link.includes("#") ?
            <HashLink to={page.link}>
               <Button
                  key={page.name}
                  onClick={handleCloseNavMenu}
                  onMouseEnter={e => setActive(true)}
                  onMouseLeave={e => setActive(false)}
                  sx={{
                     mr: 2,
                     borderBottom: (active) && "2px solid white",
                     // color:
                     color: 'white',
                     display: "block",
                     fontFamily: "Poppins, sans-serif !important",
                     // border:
                     //   page.name == "matchmaking" ? "1px solid #FF2945" : "",
                     borderRadius: "0px",
                     // "&:hover": { color: "#D71325" },
                  }}
               >
                  {page.name}
               </Button>
            </HashLink> :
            <NavLink to={page.link}>
               <Button
                  key={page.name}
                  onClick={handleCloseNavMenu}
                  onMouseEnter={e => setActive(true)}
                  onMouseLeave={e => setActive(false)}
                  className="summer22-nav-btn"
                  sx={{
                     mr: 2,
                     borderBottom: (active) && "2px solid white",
                     // color:
                     color: 'white',
                     display: "block",
                     fontFamily: "Poppins, sans-serif !important",
                     // border:
                     //   page.name == "matchmaking" ? "1px solid #FF2945" : "",
                     borderRadius: "0px",
                     // "&:hover": { color: "#D71325" },
                  }}
               >
                  {page.name}
               </Button>
            </NavLink>)
   }


   return (
      <>
         <AppBar
            position="sticky"
            sx={{
               height: '10% !important',
               backgroundImage: "linear-gradient(90deg, hsl(0deg 0% 0%) 0%, hsl(277deg 72% 16%) 38%, hsl(319deg 100% 24%) 62%, hsl(349deg 100% 42%) 100%)",
               m: 0,
               width: "100%",
               p: .5,
               fontFamily: "Poppins, sans-serif !important",
            }}
         >
            <Container maxWidth="xl" sx={{ margin: "auto" }}>
               <Toolbar disableGutters={true}>
                  <Typography
                     variant="h6"
                     noWrap
                     component="div"
                     sx={{
                        mr: 2,
                        flex: 1,
                        fontFamily: "Poppins, sans-serif !important",
                        display: { xs: "none", md: "flex" },
                     }}
                  >
                     <div /*style={{ display: "flex", alignItems: "center", gap:"5%" }}*/>
                        <a href="https://youngstartup.com/upcoming"><img
                           alt='youngstartup'
                           src="./assets/media/Nav Bar Logo.png"
                           style={{ width: '100%', maxWidth: "350px", minWidth: "150px", }}
                        /></a>
                        {/* <Stack>
                <div style={{display:'flex', height:'fit-content'}}>July 19-20</div>
                <div style={{display:'flex', height:'fit-content'}}>Hyatt Regency</div>
              </Stack> */}
                     </div>
                  </Typography>

                  <Box
                     sx={{ flex: 1, flexGrow: 1, display: { xs: "flex", md: "none" } }}
                  >
                     <IconButton
                        size="large"
                        aria-label="account of current user"
                        aria-controls="menu-appbar"
                        aria-haspopup="true"
                        onClick={handleOpenNavMenu}
                        color="inherit"
                     >
                        <MenuIcon />
                     </IconButton>
                     <Menu
                        id="menu-appbar"
                        anchorEl={anchorElNav}
                        anchorOrigin={{
                           vertical: "bottom",
                           horizontal: "left",
                        }}
                        keepMounted
                        transformOrigin={{
                           vertical: "top",
                           horizontal: "left",
                        }}
                        open={Boolean(anchorElNav)}
                        onClose={handleCloseNavMenu}
                        sx={{
                           display: { xs: "block", md: "none" },
                        }}
                     >
                        {pages.map((page) => (
                           <MenuItem
                              key={page.name}
                              onClick={handleCloseNavMenu}
                              sx={{ backgroundColor: "black" }}
                           >
                              page.link.includes("#") ?
                              <HashLink to={page.link}>
                                 <Typography
                                    textAlign="center"
                                    sx={{
                                       fontFamily: "Poppins, sans-serif !important",
                                       color: "white",
                                    }}
                                 >
                                    {page.name}
                                 </Typography>
                              </HashLink> :
                              <Link to={page.link}>
                                 <Typography
                                    textAlign="center"
                                    sx={{
                                       fontFamily: "Poppins, sans-serif !important",
                                       color: "white",
                                    }}
                                 >
                                    {page.name}
                                 </Typography>
                              </Link>
                           </MenuItem>
                        ))}
                        <MenuItem sx={{ backgroundColor: 'black' }}>
                           {/* <a href={`${baseUrl}/events/summer22/registration`} style={{ width: '100%' }}>
                             <Button className="dark-btn-red-red" sx={{borderRadius:'0px', backgroundColor:'#7C2387', fontFamily: 'Poppins, sans-serif !important', "&:hover":{backgroundColor:'#7C2387'}}} variant="contained">Register</Button>
                              <button
                                 onMouseOver={(e) => {
                                    setChevron3(1);
                                    setMargin3("1.5vw");
                                 }}
                                 onMouseLeave={() => {
                                    setChevron3(0);
                                    setMargin3("0vw");
                                 }}
                                 className="dark-btn-red"
                                 style={{
                                    marginRight: "1rem",
                                    fontWeight: "900",
                                    fontSize: "18px",
                                    width: '100%'
                                 }}
                              >
                                 <div style={{ display: "flex", alignItems: "center" }}>
                                    <ChevronRightIcon sx={{ opacity: "0" }} />
                                    <div>Register</div>
                                    <ChevronRightIcon
                                       sx={{
                                          transition: ".3s all ease-in-out",
                                          opacity: chevron3,
                                          marginLeft: margin3,
                                       }}
                                    />
                                 </div>
                              </button> 
                           </a> */}
                        </MenuItem>
                        <MenuItem sx={{ backgroundColor: 'black' }}>
                           <a href={`${baseUrl}/events/summer22/top-innovators`} style={{ width: '100%' }}>
                              {/* <Button className="dark-btn-red" sx={{borderRadius:'0px', backgroundColor:'#7C2387', fontFamily: 'Poppins, sans-serif !important', "&:hover":{backgroundColor:'#7C2387'}}} variant="contained">Register</Button> */}
                              <button
                                 onMouseOver={(e) => {
                                    setChevron4(1);
                                    setMargin4("1.5vw");
                                 }}
                                 onMouseLeave={() => {
                                    setChevron4(0);
                                    setMargin4("0vw");
                                 }}
                                 className="dark-btn-red"
                                 style={{
                                    marginRight: "1rem",
                                    fontWeight: "900",
                                    fontSize: "18px",
                                    width: '100%'
                                 }}
                              >
                                 <div style={{ display: "flex", alignItems: "center" }}>
                                    <ChevronRightIcon sx={{ opacity: "0" }} />
                                    <div>Present</div>{" "}
                                    <ChevronRightIcon
                                       sx={{
                                          transition: ".3s all ease-in-out",
                                          opacity: chevron4,
                                          marginLeft: margin4,
                                       }}
                                    />
                                 </div>
                              </button>
                           </a>
                        </MenuItem>
                     </Menu>
                  </Box>
                  <Typography
                     variant="h6"
                     noWrap
                     component="div"
                     sx={{
                        flexGrow: 1,
                        display: {
                           xs: "flex",
                           md: "none",
                           fontFamily: "Poppins, sans-serif !important",
                        },
                     }}
                  >
                     <div style={{ display: "flex", alignItems: "center", gap: '5%' }}>
                        <a href="https://youngstartup.com/upcoming"><img
                           alt='youngstartup'
                           src="./assets/media/Nav Bar Logo.png"
                           style={{ objectFit: "scale-down", minWidth: "150px", maxWidth: "250px" }}
                        /></a>
                        {/* <div style={{ display: "flex", flexDirection: "column" }}>
                <h5
                  style={{
                    fontFamily: "Poppins, sans-serif !important",
                    fontSize: ".65rem",
                    margin: "0 !important",
                  }}
                >
                  July 19-20<br/>
                  Hyatt Regency
                </h5>
              </div> */}
                     </div>
                  </Typography>
                  <Box
                     sx={{
                        flex: 1,
                        ml: 15,
                        display: { xs: "none", md: "flex", justifyContent: "left" },
                     }}
                  >
                     {pages.map((page, idx) => (
                        <NavLinkButton page={page} key={idx} />
                     ))}
                  </Box>

                  <Box
                     sx={{ flex: 1, display: window.innerWidth < 1000 ? "none" : "relative" }}
                  >
                     <div
                        style={{ display: "flex", justifyContent: "right", gap: "5%" }}
                     >

                        {/* <NavButton name={"register"} link={'https://youngstartup.com/events/summer22/registration'} borderColor={"white"} />
                        <NavButton name={'present'} link={'https://youngstartup.com/events/summer22/top-innovators'} borderColor={"white"} /> */}

                     </div>
                     <Menu
                        sx={{ mt: "45px" }}
                        id="menu-appbar"
                        anchorEl={anchorElUser}
                        anchorOrigin={{
                           vertical: "top",
                           horizontal: "right",
                        }}
                        keepMounted
                        transformOrigin={{
                           vertical: "top",
                           horizontal: "right",
                        }}
                        open={Boolean(anchorElUser)}
                        onClose={handleCloseUserMenu}
                     >
                        {settings.map((setting) => (
                           <MenuItem key={setting} onClick={handleCloseUserMenu}>
                              <Typography textAlign="center">{setting}</Typography>
                           </MenuItem>
                        ))}
                     </Menu>
                  </Box>
               </Toolbar>
            </Container>
         </AppBar>
         <Dialog
            open={open}
            onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"

         >
            <DialogContent>
               <div id="preregisterForm"></div>
            </DialogContent>
         </Dialog>
      </>
   );
};
